<template>
    <div class="public_container department_add_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true">

            </ReturnNavBar>
        </div>
        <div class="mobile_container" v-loading="loading">
            <van-form
                ref="customForm"
                :rules="customFormRules"
                error-message-align="right"
                input-align="right"
                label-width="10em"
                :show-error-message="false"
                scroll-to-error
            >
                <van-field
                    required
                    v-model="formData.department"
                    name="department"
                    label="部门名称"
                    placeholder="请输入"
                    maxlength="10"
                    :rules="[{ required: true, message: '请输入' }]"
                >
                </van-field>
                <van-field
                    v-model="formData.didText"
                    name="didText"
                    label="上级部门"
                    placeholder="请选择"
                    is-link
                    readonly
                    :disabled="!formData.pid"
                    @click="handleClickSelect('did')"
                >
                </van-field>
                <van-field
                    v-model="formData.directorText"
                    name="directorText"
                    label="部门负责人"
                    placeholder="请选择"
                    is-link
                    readonly
                    @click="handleClickSelect('user')"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                </van-field>
            </van-form>
        </div>
        <!-- 人员选择 -->
        <UserSearchSelect
            :userSelectVisible.sync="userSelectVisible"
            :userSelectTitle="'选择人员'"
            :selectType="'one'"
            :selectedUser="formData.director"
            @selectUserData="handleSelectUserData"
            v-if="userSelectVisible"
        />
        <!--级联选择-->
        <van-popup
            :style="{ height: '480px' }"
            position="bottom"
            round
            v-if="showCascaderPicker"
            v-model="showCascaderPicker"
        >
            <van-cascader
                :field-names="cascaderFieldNames"
                :options="cascaderOptions"
                :title="'选择部门'"
                @close="showCascaderPicker = false"
                @finish="handleClickCascaderFinish"
                active-color="#2990FF"
                v-model="cascaderValue"
            >
            </van-cascader>
        </van-popup>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">确定</van-button>
        </div>
    </div>
</template>

<script>
import { GetDepartmentList, DepartmentDetail, DepartmentEdit } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import UserSearchSelect from "@/components/mComponents/UserSearchSelect.vue";
export default {
    name: "MDepartmentEdit",
    components: { ReturnNavBar, UserSearchSelect },
    data() {
        return {
            pid: "",
            pName: "",
            loading: false,
            btnDisabled: false,
            formData: {
                department: "",
                did: "",
                didText: "",
                director: [],
                directorText: "",
                pid: "",
            },
            customFormRules: {},
            userSelectVisible: false,
            showCascaderPicker: false,
            departmentList: [],
            cascaderOptions: [],
            cascaderFieldNames: {
                text: "relate_name",
                value: "relate_id",
                children: "children",
            },
            cascaderValue: "",
        };
    },
    created() {
        if (this.$route.query) {
            this.formData.did = this.$route.query.did;
            this.getDepartmentDetail();
        }
        this.getDepartmentList();
    },
    methods: {
        handleClickSelect(type) {
            if (type === "user") {
                this.userSelectVisible = true;
            } else {
                this.showCascaderPicker = true;
            }
        },
        handleSelectUserData(data) {
            let new_data = data ? [data] : []
            this.formData.director = new_data.map((map) => {
                return map.uid;
            });
            this.formData.directorText = new_data
                .map((map) => {
                    return map.name;
                })
                .join(",");
            this.userSelectVisible = false;
        },
        handleClickCascaderFinish({ selectedOptions }) {
            const last = selectedOptions[selectedOptions.length - 1];
            this.formData.pid = last.relate_id;
            this.formData.didText = last.relate_name;
            this.showCascaderPicker = false;
        },
        // 获取部门详情
        getDepartmentDetail() {
            DepartmentDetail({ id: this.formData.did }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.formData.department = data.department_name;
                    this.formData.director = (data.department_heads || []).map((map) => {
                        return map.uid;
                    });
                    this.formData.directorText = (data.department_heads || [])
                        .map((map) => {
                            return map.name;
                        })
                        .join(",");
                    this.formData.pid = data.pid;
                    this.formData.didText = data.pid_info ? data.pid_info.department_name : "";
                    if(this.formData.pid == 0) {
                        this.formData.didText = data.department_name
                    }
                }
            });
        },
        //获取部门列表
        getDepartmentList() {
            GetDepartmentList().then((res) => {
                if (res.code === 200) {
                    this.departmentList = res.data || [];

                    this.cascaderOptions = res.data || [];
                } else {
                    this.$toast(res.message);
                }
            });
        },
        handleClickConfirm() {
            this.$refs.customForm.validate().then(() => {
                let postData = {
                    id: this.formData.did,
                    department_name: this.formData.department,
                    pid: this.formData.pid,
                    department_heads: this.formData.director,
                };
                this.btnDisabled = true;
                DepartmentEdit(postData).then((res) => {
                    if (res.code === 200) {
                        this.$toast({
                            message: res.message,
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                                this.$router.go(-1);
                                this.btnDisabled = false;
                            },
                        });
                    } else {
                        this.btnDisabled = false;
                        this.$toast(res.message);
                    }
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.department_add_wrap {
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: #f7f8fa;

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
}
</style>
